export type ClosedPathType = 'search' | 'summary' | 'result';

/** このアプリケーション内のパスに関する定数・処理のクラス。 */
export default class Path {
  /** ルートパス（検索画面）の文字列。 */
  static readonly ROOT = '/';
  /** 検索画面のパスの文字列。 */
  static readonly SEARCH = '/search';
  /** サマリー画面のパスの文字列。 */
  static readonly SUMMARY = '/summary';
  /** 結果画面のパスの文字列。 */
  static readonly RESULT = '/result';
  /** 一般開放の検索画面のパスの文字列 */
  static readonly PUBLC_ROOT = '/public';
  /** 一般開放の検索画面のパスの文字列 */
  static readonly PUBLC_SEARCH = '/public/search';
  /** 一般開放のサマリー画面のパスの文字列 */
  static readonly PUBLC_SUMMARY = '/public/summary';
  /** 一般開放の結果画面のパスの文字列 */
  static readonly PUBLC_RESULT = '/public/result';
  /** 一般開放の搭乗便一覧画面のパスの文字列 */
  static readonly PUBLIC_FLIGHTLIST = '/public/flightlist';

  /**
   * 現在ページが検索画面であるかを判別する。
   * @param pathName 現在ページURLのパス名。
   */
  static isSearch(pathName: string) {
    return pathName === this.ROOT || pathName.includes(this.SEARCH);
  }

  /**
   * 現在ページがサマリー画面であるかを判別する。
   * @param pathName 現在ページURLのパス名。
   */
  static isSummary(pathName: string) {
    return pathName.includes(this.SUMMARY);
  }

  /**
   * 現在ページが結果画面であるかを判別する。
   * @param pathName 現在ページURLのパス名。
   */
  static isResult(pathName: string) {
    return pathName.includes(this.RESULT);
  }

  /**
   * 現在ページが一般開放画面であるかを判別する。
   * @param pathName 現在ページURLのパス名。
   */
  static isPublic(pathName: string) {
    return pathName.includes(this.PUBLC_ROOT);
  }

  /**
   * 現在ページが一般開放の検索画面か判別する
   * @param pathName 現在ページURLのパス名。
   */
  static isPublicSearch(pathName: string) {
    return pathName === this.PUBLC_ROOT || pathName.includes(this.PUBLC_SEARCH);
  }

  /**
   * 現在ページが一般開放のサマリー画面か判別する
   * @param pathName 現在ページURLのパス名。
   */
  static isPublicSummary(pathName: string) {
    return pathName.includes(this.PUBLC_SUMMARY);
  }

  /**
   * 現在ページが一般開放の結果画面か判別する
   * @param pathName 現在ページURLのパス名。
   */
  static isPublicResult(pathName: string) {
    return pathName.includes(this.PUBLC_RESULT);
  }

  /**
   * 空港アクセスナビにおける現在のPathを返す
   */
  static getClosedPathType(pathName: string): ClosedPathType | null {
    if(this.isSearch(pathName)) {
      return 'search';
    }
    else if(this.isSummary(pathName)) {
      return 'summary';
    }
    else if(this.isResult(pathName)) {
      return 'result';
    }
    return null;
  }
}
